import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';
import RequestStatus from 'entity/RequestStatus';
import RequestStatusType from 'enums/RequestStatusType';
import Paging from 'rest/Paging';
import UtilController from 'rest/UtilController';

@Injectable({
  providedIn: 'root',
})
export class UtilService extends Loggable {
  private utilController = new UtilController();

  public constructor(private store: Store<AppState>) {
    super();
    this.setDisplayName('UtilService');
  }

  public getRequestStatus(requestStatusId: string): Promise<RequestStatus> {
    return this.utilController.getRequestStatus(requestStatusId);
  }
  public getRequests(status?: RequestStatusType, page?: Paging): Promise<RequestStatus[]> {
    return this.utilController.getRequests(status, page);
  }
}
